var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchLoads(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_268_61728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.6667 51.3333C33.2337 51.3333 28 46.0997 28 39.6667C28 33.2337 33.2337 28 39.6667 28C46.0997 28 51.3333 33.2337 51.3333 39.6667C51.3333 46.0997 46.0997 51.3333 39.6667 51.3333ZM39.6667 30.3333C34.5193 30.3333 30.3333 34.5193 30.3333 39.6667C30.3333 44.814 34.5193 49 39.6667 49C44.814 49 49 44.814 49 39.6667C49 34.5193 44.814 30.3333 39.6667 30.3333Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8333 56.0001C54.5347 56.0001 54.236 55.8858 54.0073 55.6594L46.2653 47.9174C45.8103 47.4624 45.8103 46.7228 46.2653 46.2678C46.7203 45.8128 47.46 45.8128 47.915 46.2678L55.657 54.0098C56.112 54.4648 56.112 55.2044 55.657 55.6594C55.4307 55.8858 55.132 56.0001 54.8333 56.0001Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 46.6666H5.83333C3.90366 46.6666 2.33333 45.0963 2.33333 43.1666V17.4999C2.33333 16.8559 2.85599 16.3333 3.49999 16.3333H43.1667C43.8107 16.3333 44.3333 16.8559 44.3333 17.4999V24.6399C44.3333 25.2839 43.8107 25.8066 43.1667 25.8066C42.5227 25.8066 42 25.2839 42 24.6399V18.6666H4.66666V43.1666C4.66666 43.8083 5.19166 44.3333 5.83333 44.3333H24.5C25.144 44.3333 25.6667 44.8559 25.6667 45.4999C25.6667 46.1439 25.144 46.6666 24.5 46.6666Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1667 25.6666H17.5C16.856 25.6666 16.3333 25.1439 16.3333 24.4999C16.3333 23.8559 16.856 23.3333 17.5 23.3333H29.1667C29.8107 23.3333 30.3333 23.8559 30.3333 24.4999C30.3333 25.1439 29.8107 25.6666 29.1667 25.6666Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5 18.6667H1.16667C0.522667 18.6667 0 18.144 0 17.5V8.16667C0 7.52267 0.522667 7 1.16667 7H45.5C46.144 7 46.6667 7.52267 46.6667 8.16667V17.5C46.6667 18.144 46.144 18.6667 45.5 18.6667ZM2.33333 16.3333H44.3333V9.33333H2.33333V16.3333Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5 9.33333C45.2013 9.33333 44.9027 9.219 44.674 8.99267L38.017 2.33333H8.64967L1.99267 8.99267C1.53767 9.44767 0.798005 9.44767 0.343005 8.99267C-0.111995 8.53767 -0.111995 7.798 0.343005 7.343L7.343 0.343C7.56 0.123667 7.85634 0 8.16667 0H38.5C38.8103 0 39.1067 0.123667 39.326 0.340667L46.326 7.34067C46.781 7.79567 46.781 8.53533 46.326 8.99033C46.0973 9.219 45.7987 9.33333 45.5 9.33333Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_268_61728"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchLoads);
export default __webpack_public_path__ + "static/media/search_loads.e6f3a42fdfe7ba5e8254b3f158d4a7c7.svg";
export { ForwardRef as ReactComponent };